import React from "react";
import styles from "./aboutUs.module.css";
import Logo from "../../assets/logo/logoyello.png";
import Profile3 from "../../assets/aboutUsPage/profile3.jpg";
import profile2 from "../../assets/aboutUsPage/profile2.jpg";
import Profile4 from "../../assets/aboutUsPage/profile4.jpg";

// imported another quote files--------------------------------
// import Quote01Page from "../quote01Page/index"

function WhoWeAreGrp() {
  return (
    <div className={styles.box}>
      <section className={styles.whoWeAre}>
        <header className={styles.whoWeAreTitle}>
          <h1 className={styles.aboutthecompany}>ABOUT THE COMPANY</h1>
        </header>

        <div className={styles.whoWeAreDiv2}>
          <div className={styles.whoWeAreDiv3}>
            <div className={styles.weWeAreColumn}>
              <div className={styles.whoWeAreDiv4}>
                <div className={styles.whoWeAreDiv5}>
                  <div className={styles.weWeAreColumn}>
                    <div className={styles.whoWeAreDiv6}>
                      {/* <div className="card">                   
                      <div class="card-inner">
                        <div class="card-front">Front Side</div>
                          <div class="card-back">Back Side</div>
                        </div>  </div> */}
                      <img src={Logo} alt="logo" className={styles.img} />
                      <img
                        src={Profile3}
                        alt="Profile3"
                        className={styles.img2}
                      />
                    </div>
                  </div>
                  <div className={styles.weWeAreColumn2}>
                    <div className={styles.whoWeAreDiv7}>
                      <img
                        src={profile2}
                        alt="profile2"
                        className={styles.img3}
                      />
                      <img src={Profile4} alt="profile4" className={styles.img4} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <article className={styles.weWeAreColumn3}>
              <div className={styles.whoWeAreDiv8}>
                <h2 className={styles.wearetheStarlinklab}>
                  <span style={{ color: "rgba(255,255,255,1)" }}>
                    We are the 
                  </span>
                  <span style={{ color: "rgba(255,214,72,1)" }}>
                    Starlinklab
                  </span>
                </h2>
                <p className={styles.description}>
                  At{" "}
                  <span style={{ color: "rgba(255,214,72,1)" }}>
                    StarlinkLab
                  </span>
                  , we specialize in crafting custom IT solutions that drive
                  business growth, enhance productivity, and create impact
                  digital experiences.
                  <br />
                  With a team of skilled developers, designers, and tech
                  experts, <br />
                  we have successfully delivered innovative and salable
                  solutions to businesses worldwide.
                  <br />
                  <br />
                  From web and mobile app development to UI/UX design and IT
                  consultation, our expertise covers a broad spectrum of
                  technology-driven services. <br />
                  We take a partnership-first approach, ensuring that every
                  solution we develop aligns with our clients' vision and
                  business objectives.
                </p>

                <p
                  className={styles.description}
                  // className={
                  //   styles.weleverageadvancedtechnologyapurposeDrivenapproachandapassionforcustomerEccentricitytobuildtransformationapps5Employees5ProjectsDelivered5YearExperienceCustomersupport5
                  // }
                >
                  We leverage advanced technology, a purpose-driven approach,
                  and a passion for customer-eccentricity to build
                  transformation apps.
                  <br />
                  <span style={{ fontWeight: 700, color: "grey" }}>
                    <br />
                    💼 5+ Employees | 🚀 5+ Projects Delivered | 🌍 5+ year
                    Experience | Customer support 5
                  </span>
                </p>

                {/* <blockquote className={styles.quote}>
                  "Think Big , We'll make IT Possible"
                </blockquote> */}
                <p className="mt-4 text-lg text-gray-400 quote ">
          "Think Big , We'll make IT Possible"
          </p>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WhoWeAreGrp;
